import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import type { ComponentType } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { OVERLAY_CONNECTED_POSITIONS } from './overlay.config';

const DEFAULT_OVERLAY_CONFIG = { hasBackdrop: true, backdropClass: 'backdrop-class' };

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  overlayRef: OverlayRef;
  overlayDialogData: any;
  overlayBarClass: string;
  floorNo: string;
  totalNumberOfFloors: number;
  isTenantReplacement: boolean;
  constructor(private overlay: Overlay) {}

  public openOverlayBox<T>(
    component: ComponentType<T>,
    data: any,
    origin: HTMLElement,
    cssClass?: string,
    nonRentableFloor?: { floorNo: string; totalNumberOfFloors: number },
    type = 'item',
    nonRentableSpace?: boolean
  ) {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(origin)
      .withPositions(OVERLAY_CONNECTED_POSITIONS[type]);
    const config = {
      ...DEFAULT_OVERLAY_CONFIG,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    };
    this.overlayRef = this.overlay.create(config);
    this.overlayRef.backdropClick().pipe(take(1)).subscribe(this.disposeBox.bind(this));

    const instance = this.attachDialogContainer(this.overlayRef, component);
    this.overlayDialogData = data;
    this.overlayBarClass = cssClass;
    if (nonRentableFloor) {
      this.floorNo = nonRentableFloor.floorNo;
      this.totalNumberOfFloors = nonRentableFloor.totalNumberOfFloors;
    }
    if (nonRentableSpace) {
      this.floorNo = data.floor;
    }
    return instance.overlayEmit;
  }

  private attachDialogContainer(overlayRef: OverlayRef, component: ComponentType<any>): any {
    const containerPortal = new ComponentPortal<any>(component, null);
    const containerRef: ComponentRef<any> = overlayRef.attach(containerPortal);
    return containerRef.instance;
  }

  public disposeBox() {
    this.overlayRef.detach();
    this.overlayRef.detachBackdrop();
    this.overlayRef.dispose();
    this.overlayRef = null;
  }
}
